const sortOptions = {
	MostRecent: { display: 'Most recent', order: 'SubmissionTime:desc' },
	Helpful: { display: 'Most helpful', order: 'TotalPositiveFeedbackCount:desc' },
	Highest: { display: 'Highest to lowest rating', order: 'Rating:desc' },
	Lowest: { display: 'Lowest to highest rating', order: 'Rating:asc' }
};

module.exports = sortOptions;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/enums/review-sort-enum.js
 **/